// extracted by mini-css-extract-plugin
module.exports = {"slider":"fV5aJCNI5LYclxxVsrXnyQ==","sliderOFF":"_5Swh2lM1H8EgKDUYlkrCUQ==","status":"GQPWFtf7Ttd7MFbYq2r6-A==","disabled":"_4UjEsd2jOFEVEQPSd3Pyfw=="};